/**
 * Utility function to get the correct public asset path
 * This ensures assets work correctly when the app is served from a subpath
 */
export const getPublicAssetPath = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // Use REACT_APP_PUBLIC_URL from environment, defaulting to empty string
  const publicUrl = process.env.REACT_APP_PUBLIC_URL || '';

  // Ensure we don't have double slashes
  return publicUrl ? `${publicUrl}/${cleanPath}` : `/${cleanPath}`;
};

/**
 * Helper specifically for lottie files
 */
export const getLottiePath = (filename: string): string => {
  return getPublicAssetPath(filename);
};

/**
 * Helper specifically for image files
 */
export const getImagePath = (path: string): string => {
  return getPublicAssetPath(path);
};
